"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryService = void 0;
var dictionary_mock_1 = require("./dictionary.mock");
var login_1 = require("../../src/api/login");
var DictionaryService = /** @class */ (function () {
    function DictionaryService() {
    }
    // 获取字典，保存入公共参数中
    DictionaryService.getDictionary = function (list) {
        return __awaiter(this, void 0, void 0, function () {
            var localDicObj, remoteDicObj;
            var _this = this;
            return __generator(this, function (_a) {
                localDicObj = JSON.parse(JSON.stringify(dictionary_mock_1.dictionaryListObj));
                remoteDicObj = {};
                return [2 /*return*/, (0, login_1.Remotedictionary)({ busTypeCodes: list }).then(function (res) {
                        list.map(function (item) { var _a; return remoteDicObj[item] = (_a = res.content.filter(function (remoteItem) { return remoteItem.busTypeCode == item; })[0]) === null || _a === void 0 ? void 0 : _a.dictList; });
                        // 合并字典
                        var tarAllDicObj = __assign(__assign({}, remoteDicObj), localDicObj);
                        list.map(function (item) {
                            _this.dictionary[item] = (tarAllDicObj[item] || []).map(function (item) {
                                item['label'] = item.busName;
                                item['value'] = item.busCode;
                                return item;
                            });
                        });
                        return list;
                    })];
            });
        });
    };
    // 根据要求，获取所有字典
    DictionaryService.getAllNeedDic = function (list) {
        return this.getDictionary(list);
    };
    // 根据字典与目标值获取目标名称
    DictionaryService.getTarLabel = function (type, value) {
        var tarLabel = '';
        (this.dictionary[type] || []).map(function (item) {
            if (item.value == value)
                tarLabel = item.label;
        });
        return tarLabel;
    };
    // 根据字典与目标名称获取目标值
    DictionaryService.getTarValue = function (type, value) {
        var tarValue = '';
        (this.dictionary[type] || []).map(function (item) {
            if (item.name == value)
                tarValue = item.value;
        });
        return tarValue;
    };
    // 获取下拉列表
    DictionaryService.getOptions = function (type, hasAll) {
        if (hasAll === void 0) { hasAll = false; }
        var list = this.dictionary[type] || [];
        if (hasAll)
            list.unshift({ label: '全部', value: '' });
        return list;
    };
    DictionaryService.dictionary = {};
    return DictionaryService;
}());
exports.DictionaryService = DictionaryService;
